import { CImage } from "@coreui/react-pro";
import { React } from "react";

const Error404 = () => {
  return (
    <>
      <CImage src="/sabakLogo.png" className="mb-5" height={75} alt="Logo" />
      <h1 className="fw-bolder fs-4x text-gray-700 mb--5">Sayfa bulunumadı.</h1>

      <div className="fw-bold fs-3 text-gray-400 mt-5">
        Aradığınız sayfa bulunumadı. <br />
      </div>
    </>
  );
};

export { Error404 };
